import { AnyChatForm } from '@anyx/feature-crm/shared';

export function ImageVideoBlock() {
  return <AnyChatForm.Block>BroadcastImageVideoBlock</AnyChatForm.Block>;
}
